<template>
  <div class="mine-page">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- mine-top -->
      <div class="mine-top" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
        <div class="mine-avatar-row">
          <img :src="getAvatarUrl(userInfo.header_img)" @error="handleAvatarError" alt="" class="avatar" @click="doLogin()">
          <div class="mine-user-info">
            <div class="user-name-row">
              <span class="username">{{ userInfo.username || 'xiao123456' }}</span>
              <img src="/img/mine/vip.png" alt="VIP" class="vip-icon">
            </div>
            <p class="credit-score"> 信譽分:{{ userInfo.score !== undefined ? userInfo.score : 100 }} </p>
            <div class="progress-row">
              <div class="progress-bar">
                <span style="width: 100%;"></span>
              </div>
              <span class="progress-label"> 累積積分1000 </span>
            </div>
          </div>
        </div>

        <div class="integral-card">
          <div class="integral-item" @click="$router.push('/Recharge')">
            <img src="/img/mine/icon-12ac.png" alt="">
            <span>積分儲值</span>
          </div>
          <div class="integral-item" @click="doWithdrawal()">
            <img src="/img/mine/icon-c113.png" alt="">
            <span>積分提款</span>
          </div>
        </div>
      </div>

      <!-- mine-center -->
      <div class="mine-center">
        <div class="balance-card">
          <div class="balance-title">擁有的積分</div>
          <div class="balance-row">
            <h1>{{ formatMoney(userInfo.money) }}</h1>
            <div class="balance-refresh" @click="shuaxin()">
              <span>新台幣</span>
              <i class="van-icon van-icon-replay"></i>
            </div>
          </div>
        </div>

        <div class="menu-grid">
          <div class="menu-item" @click="$router.push('/Infomation')">
            <img src="/img/mine/icon-44a0.png" alt="">
            <span>基本資訊</span>
          </div>
          <div class="menu-item" @click="$router.push('/MoneyRecord')">
            <img src="/img/mine/icon-9bcb.png" alt="">
            <span>積分記錄</span>
          </div>
          <div class="menu-item" @click="$router.push('/WithdrawRecord')">
            <img src="/img/mine/icon-3d10.png" alt="">
            <span>提款歷史</span>
          </div>
          <div class="menu-item" @click="$router.push('/GameRecord')">
            <img src="/img/mine/icon-5311.png" alt="">
            <span>歷史記錄</span>
          </div>
          <div class="menu-item" @click="toNotice()">
            <img src="/img/mine/icon-9363.png" alt="">
            <span>通知</span>
          </div>
          <div class="menu-item" @click="$router.push('/RevenueRecord')">
            <img src="/img/mine/icon-3a81.png" alt="">
            <span>查看歷史記錄</span>
          </div>
          <div class="menu-item" @click="$router.push('/SetLoginPassword')">
            <img src="/img/mine/icon-26a5.png" alt="">
            <span>登錄密碼</span>
          </div>
          <div class="menu-item" @click="$router.push('/Setbank')">
            <img src="/img/mine/bank.png" alt="">
            <span>資金管理</span>
          </div>
        </div>

        <button type="button" class="logout-btn" @click="loginout()"> 註銷 </button>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        username: "xiao123456",
        score: 100,
        money: 0,
        header_img: "/img/mine/avatar.png",
        lv_name: "VIP"
      },
      menu_top: 40,
      isLoading: false,
      kefu: ""
    };
  },
  methods: {
    formatMoney(val) {
      if (val === undefined || val === null || val === '') return '0';
      return String(val);
    },
    getAvatarUrl(img) {
      if (!img) return "/img/mine/avatar.png";
      if (img.startsWith("http") || img.startsWith("/")) return img;
      return "/" + img;
    },
    handleAvatarError(e) {
      e.target.src = "/img/mine/avatar.png";
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem("token")) {
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: "/Login" });
        }
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config"
      }).then(res => {
        if (res && res.data) {
          this.kefu = res.data.kefu;
        }
      });
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Setting" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    toNotice() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Notice" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem("token")) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: "/Login" });
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Infomation" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    doPay() {
      this.$router.push({
        name: "Recharge",
        params: {
          balance: this.userInfo.money
        }
      });
    },
    doWithdrawal() {
      this.$router.push('/Withdraw');
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("Withdraw");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    shuaxin() {
      this.getUserInfo();
      this.$toast(this.$t("reservation.refresh"));
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info"
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.userInfo = Object.assign({}, this.userInfo, res.data);
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          }
        } else if (res && res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toServicePage() {
      if (this.kefu) {
        window.location.href = this.kefu;
      }
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: "/Login" });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getBasicConfig();
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
.mine-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 120px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mine-top {
  position: relative;
  width: 100%;
  padding: 60px 30px 96px 30px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.mine-avatar-row {
  display: flex;
  align-items: center;
}

.mine-avatar-row .avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid #ffffff;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}

.mine-user-info {
  margin-left: 28px;
  flex: 1;
  color: #ffffff;
}

.user-name-row {
  display: flex;
  align-items: center;
}

.user-name-row .username {
  font-size: 34px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
  letter-spacing: 0.5px;
}

.user-name-row .vip-icon {
  height: 36px;
  margin-left: 14px;
  object-fit: contain;
  vertical-align: middle;
}

.credit-score {
  margin: 8px 0 0 0;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
}

.progress-row {
  display: flex;
  align-items: center;
  margin-top: 14px;
}

.progress-bar {
  width: 220px;
  height: 10px;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 5px;
  overflow: hidden;
}

.progress-bar span {
  display: block;
  height: 100%;
  background: #ffffff;
  border-radius: 5px;
}

.progress-label {
  margin-left: 14px;
  font-size: 22px;
  color: #ffffff;
  white-space: nowrap;
  font-weight: 500;
}

/* integral-card (floating white card inside mine-top) */
.integral-card {
  position: absolute;
  left: 30px;
  right: 30px;
  bottom: -50px;
  height: 110px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(79, 43, 138, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 10;
}

.integral-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  position: relative;
  transition: opacity 0.15s ease;
}

.integral-item:active {
  opacity: 0.75;
}

.integral-item:first-child::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 44px;
  background-color: #ebebeb;
}

.integral-item img {
  width: 46px;
  height: 46px;
  object-fit: contain;
  margin-right: 14px;
}

.integral-item span {
  font-size: 28px;
  font-weight: 700;
  color: #3b1d75;
  letter-spacing: 0.5px;
}

/* mine-center */
.mine-center {
  padding: 0 30px;
  margin-top: 80px;
}

/* balance-card */
.balance-card {
  width: 100%;
  padding: 32px;
  background: linear-gradient(135deg, #9b5195 0%, #7b3877 100%);
  border-radius: 20px;
  color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(123, 56, 119, 0.22);
}

.balance-title {
  font-size: 26px;
  font-weight: 600;
  color: #ffffff;
  opacity: 0.95;
}

.balance-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
}

.balance-row h1 {
  font-size: 54px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1;
  letter-spacing: -0.5px;
}

.balance-refresh {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.balance-refresh:active {
  opacity: 0.75;
}

.balance-refresh span {
  font-size: 24px;
  color: #ffffff;
  opacity: 0.9;
  margin-right: 14px;
}

.balance-refresh i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  color: #904d88;
  font-size: 26px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* menu-grid */
.menu-grid {
  width: 100%;
  margin-top: 28px;
  padding: 44px 10px 40px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.035);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 42px;
  box-sizing: border-box;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.menu-item:active {
  opacity: 0.75;
  transform: scale(0.96);
}

.menu-item img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  margin-bottom: 12px;
}

.menu-item span {
  font-size: 24px;
  color: #3b1d75;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.3px;
}

/* logout-btn */
.logout-btn {
  width: 100%;
  height: 90px;
  margin-top: 48px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  border-radius: 18px;
  border: none;
  color: #ffffff;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(234, 79, 182, 0.3);
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.logout-btn:active {
  opacity: 0.85;
  transform: scale(0.99);
}
</style>
